import React, { Component } from "react";
import { Container, Responsive, Grid, Image, Button } from "semantic-ui-react";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import { push } from "react-router-redux";

const typeDevelopmentSelector = [
  {
    key: "home",
    value: "home",
    text: "Casa"
  },
  {
    key: "department",
    value: "department",
    text: "Departamento"
  }
];

class PropertyComp extends Component {
  constructor(props) {
    super(props);
  }

  onPropertyClick() {}

  renderInDesktop() {
    if (this.props.rightImage) {
      return (
        <Grid columns={2} style={{ ...this.props.style }}>
          <Grid.Column
            width={7}
            style={{
              height: 434,
              padding: 0,
              backgroundColor: "#f3f9fb"
            }}
          >
            <Grid centered verticalAlign="middle">
              <Grid.Column width={12}>
                <div
                  style={{
                    marginTop: "17%"
                  }}
                >
                  <p
                    style={{
                      color: "#023552"
                    }}
                  >
                    {this.props.propertyType}
                  </p>
                  <p
                    style={{
                      color: "#023552",
                      marginTop: "1rem"
                    }}
                  >
                    {this.props.address}
                  </p>
                  <h3
                    style={{
                      fontSize: "32px",
                      color: "#023552",
                      cursor: "pointer"
                    }}
                    onClick={() => {
                      this.props.push(
                        this.props.url + "/detalle/" + this.props.idprop
                      );
                      window.scroll({
                        top: document.getElementById("nav").offsetTop,
                        behavior: "auto"
                      });
                    }}
                  >
                    {this.props.title}
                  </h3>

                  <div
                  className="propertyComp__description-containe"
                    dangerouslySetInnerHTML={{
                      __html: this.props.description
                    }}
                  />
                </div>
                <div>
                  <Button
                    className="DButton"
                    onClick={() => {
                      this.props.push(
                        this.props.url + "/detalle/" + this.props.idprop
                      );
                      window.scroll({
                        top: document.getElementById("nav").offsetTop,
                        behavior: "auto"
                      });
                    }}
                  >
                    VER PROPIEDAD
                  </Button>
                </div>
              </Grid.Column>
            </Grid>
          </Grid.Column>

          <Grid.Column
            width={9}
            style={{ padding: 0, cursor: "pointer" }}
            onClick={() => {
              this.props.push(this.props.url + "/detalle/" + this.props.idprop);
              window.scroll({
                top: document.getElementById("nav").offsetTop,
                behavior: "auto"
              });
            }}
          >
            <div
              style={{
                width: "100%",
                height: "100%",
                backgroundImage: "url(" + this.props.image + ")",
                backgroundSize: "cover",
                backgroundPosition: "center",
                position: "absolute",
                display: "block"
              }}
            >
              <div
                className="property-hover"
                style={{
                  width: "100%",
                  height: "100%"
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center"
                  }}
                >
                  <div
                    style={{
                      marginTop: "30%"
                    }}
                  >
                    <Button
                      style={{
                        backgroundColor: "#5aa7d1",
                        color: "#fff",
                        fontSize: "15px",
                        padding: "15px",
                        fontWeight: 300,
                        fontFamily: "Lato",
                        borderRadius: "30px",
                        height: "60px",
                        width: "230px",
                        display: "none"
                      }}
                      className="button-property"
                    >
                      VER PROPIEDAD
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </Grid.Column>
        </Grid>
      );
    } else {
      return (
        <Grid columns={2} style={{ ...this.props.style }}>
          <Grid.Column
            width={9}
            style={{ padding: 0, cursor: "pointer" }}
            onClick={() => {
              this.props.push(this.props.url + "/detalle/" + this.props.idprop);
              window.scroll({
                top: document.getElementById("nav").offsetTop,
                behavior: "auto"
              });
            }}
          >
            <div style={{ height: "100%", width: "100%" }}>
              <div
                style={{
                  width: "100%",
                  height: "100%",
                  backgroundImage: "url(" + this.props.image + ")",
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                  position: "absolute",
                  display: "block"
                }}
              >
                <div
                  className="property-hover"
                  style={{
                    width: "100%",
                    height: "100%"
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center"
                    }}
                  >
                    <div
                      style={{
                        marginTop: "30%"
                      }}
                      onClick={() => {
                        this.props.push(
                          this.props.url + "/detalle/" + this.props.idprop
                        );
                        window.scroll({
                          top: document.getElementById("nav").offsetTop,
                          behavior: "auto"
                        });
                      }}
                    >
                      <Button
                        style={{
                          backgroundColor: "#5aa7d1",
                          color: "#fff",
                          fontSize: "15px",
                          padding: "15px",
                          fontWeight: 300,
                          fontFamily: "Lato",
                          borderRadius: "30px",
                          height: "60px",
                          width: "230px",
                          display: "none"
                        }}
                        className="button-property"
                        onClick={() => {
                          this.props.push(
                            this.props.url + "/detalle/" + this.props.idprop
                          );
                          window.scroll({
                            top: document.getElementById("nav").offsetTop,
                            behavior: "auto"
                          });
                        }}
                      >
                        VER PROPIEDAD
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Grid.Column>
          <Grid.Column
            width={7}
            style={{
              height: 434,
              padding: 0,
              backgroundColor: "#f3f9fb"
            }}
          >
            <Grid centered>
              <Grid.Column width={12}>
                <div
                  style={{
                    marginTop: "17%"
                  }}
                >
                  <p
                    style={{
                      color: "#023552"
                    }}
                  >
                    {this.props.propertyType}
                  </p>
                  <p
                    style={{
                      color: "#023552",
                      marginTop: "1rem"
                    }}
                  >
                    {this.props.address}
                  </p>
                  <h3
                    style={{
                      fontSize: "32px",
                      color: "#023552",
                      padding: 0,
                      margin: 0,
                      cursor: "pointer",
                      marginBottom: "1rem"
                    }}
                    onClick={() => {
                      this.props.push(
                        this.props.url + "/detalle/" + this.props.idprop
                      );
                      window.scroll({
                        top: document.getElementById("nav").offsetTop,
                        behavior: "auto"
                      });
                    }}
                  >
                    {this.props.title}
                  </h3>

                  <div
                  className="propertyComp__description-containe"
                    dangerouslySetInnerHTML={{ __html: this.props.description }}
                  />
                </div>
                <div>
                  <Button
                    className="DButton"
                    onClick={() => {
                      this.props.push(
                        this.props.url + "/detalle/" + this.props.idprop
                      );
                      window.scroll({
                        top: document.getElementById("nav").offsetTop,
                        behavior: "auto"
                      });
                    }}
                  >
                    VER PROPIEDAD
                  </Button>
                </div>
              </Grid.Column>
            </Grid>
          </Grid.Column>
        </Grid>
      );
    }
  }
  renderInTablet() {
    return (
      <div
        style={{
          display: "flex",
          flexFlow: "column",
          marginBottom: "4rem"
        }}
      >
        <div>
          <p
            style={{
              color: "#023552",
              padding: 0,
              margin: 0
            }}
          >
            {this.props.propertyType}
          </p>
          <p
            style={{
              color: "#023552",
              marginTop: "1rem"
            }}
          >
            {this.props.address}
          </p>
          <h3
            style={{
              fontSize: "1.7rem",
              color: "#023552",
              padding: 0,
              margin: "0 0 1rem 0"
            }}
            onClick={() => {
              this.props.push(this.props.url + "/detalle/" + this.props.idprop);
              window.scroll({
                top: document.getElementById("nav").offsetTop,
                behavior: "auto"
              });
            }}
          >
            {this.props.title}
          </h3>
          <div
            style={{
              fontWeight: 300,
              fontFamily: "Lato",
              lineHeight: "30px"
            }}
            dangerouslySetInnerHTML={{
              __html: this.props.description
            }}
          />
        </div>

        <div>
          <div>
            <Image
              src={this.props.image}
              style={{
                width: "100%"
              }}
              onClick={() => {
                this.props.push(
                  this.props.url + "/detalle/" + this.props.idprop
                );
                window.scroll({
                  top: document.getElementById("nav").offsetTop,
                  behavior: "auto"
                });
              }}
            />
          </div>
          <div
            style={{
              marginTop: "2rem",
              display: "flex",
              justifyContent: "center"
            }}
          >
            <Button
              className="DButton"
              onClick={() => {
                this.props.push(
                  this.props.url + "/detalle/" + this.props.idprop
                );
                window.scroll({
                  top: document.getElementById("nav").offsetTop,
                  behavior: "auto"
                });
              }}
            >
              VER PROPIEDAD
            </Button>
          </div>
        </div>
      </div>
    );
  }
  renderInMobile() {
    return (
      <div
        style={{
          display: "flex",
          flexFlow: "column",
          marginBottom: "4rem"
        }}
      >
        <div>
          <p
            style={{
              color: "#023552",
              padding: 0,
              margin: 0
            }}
          >
            {this.props.propertyType}
          </p>
          <p
            style={{
              color: "#023552",
              marginTop: "1rem"
            }}
          >
            {this.props.address}
          </p>
          <h3
            style={{
              fontSize: "1.7rem",
              color: "#023552",
              padding: 0,
              margin: "0 0 1rem 0"
            }}
            onClick={() => {
              this.props.push(this.props.url + "/detalle/" + this.props.idprop);
              window.scroll({
                top: document.getElementById("nav").offsetTop,
                behavior: "auto"
              });
            }}
          >
            {this.props.title}
          </h3>
          <p
            style={{
              fontWeight: 300,
              fontFamily: "Lato",
              lineHeight: "30px",
              marginBottom: "2rem"
            }}
            dangerouslySetInnerHTML={{
              __html: this.props.description
            }}
          />
        </div>

        <div>
          <div>
            <Image
              src={this.props.image}
              style={{
                width: "100%"
              }}
              onClick={() => {
                this.props.push(
                  this.props.url + "/detalle/" + this.props.idprop
                );
                window.scroll({
                  top: document.getElementById("nav").offsetTop,
                  behavior: "auto"
                });
              }}
            />
          </div>
          <div
            style={{
              marginTop: "2rem",
              display: "flex",
              justifyContent: "center"
            }}
          >
            <Button
              className="DButton"
              onClick={() => {
                this.props.push(
                  this.props.url + "/detalle/" + this.props.idprop
                );
                window.scroll({
                  top: document.getElementById("nav").offsetTop,
                  behavior: "auto"
                });
              }}
            >
              VER PROPIEDAD
            </Button>
          </div>
        </div>
      </div>
    );
  }
  render() {
    return (
      <div>
        <Responsive {...Responsive.onlyMobile}>
          {this.renderInMobile()}
        </Responsive>
        <Responsive {...Responsive.onlyTablet}>
          {this.renderInTablet()}
        </Responsive>
        <Responsive {...Responsive.onlyComputer}>
          {this.renderInDesktop()}
        </Responsive>
      </div>
    );
  }
}
const mapStateToProps = ({ data }) => {
  const { pages, currentlanguage } = data;
  return {
    pages,
    currentlanguage
  };
};

const mapDispatchToProps = dispatch => {
  return {
    push: to => {
      dispatch(push(to));
    }
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(PropertyComp)
);
